import { hasOnlyLoyaltyPurchasePointsItems, isLoyaltyPurchasePointsItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getLoyaltyPurchasePointsItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items) => items.filter(isLoyaltyPurchasePointsItem),
  reselectShallowEqual,
)

export const getCartHasOnlyLoyaltyPurchasePointsItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  hasOnlyLoyaltyPurchasePointsItems,
)

export default getLoyaltyPurchasePointsItems
